var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"step"},[_c('el-steps',{attrs:{"active":_vm.$store.getters.autoAct,"simple":""}},[_c('el-step',{attrs:{"title":"上传模型"}}),_c('el-step',{attrs:{"title":"模型优化"}}),_c('el-step',{attrs:{"title":"选择打印机"}}),_c('el-step',{attrs:{"title":"选择耗材"}}),_c('el-step',{attrs:{"title":"表面处理"}}),_c('el-step',{attrs:{"title":"产品测试"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }